import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeading12 from 'components/common/text/DazzedHeading12'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  root: {},
  dateFilterItem: {
    cursor: 'pointer',
    border: '1px solid #CCD4E4',
    padding: '3px 10px',
    '&:first-child': {
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
      borderRight: 'none'
    },
    '&:last-child': {
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      borderLeft: 'none'
    }
  },
  selectedItem: {
    background: '#CCD4E4'
  },
  itemText: {
    color: '#727B8C'
  },
  selectedItemText: {
    color: '#3C52EF'
  }
}))

const DateFilter = ({ pastXDays, onChange }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const dateFilterItems = [
    {
      value: 7,
      text: t('pages.copilotControl.mainPage.dateFilter.last7Days')
    },
    {
      value: 30,
      text: t('pages.copilotControl.mainPage.dateFilter.last30Days')
    },
    {
      value: null,
      text: t('pages.copilotControl.mainPage.dateFilter.all')
    }
  ]

  return (
    <Grid container className={classes.root}>
      {dateFilterItems.map((item, index) => (
        <Grid
          item
          key={index}
          className={[classes.dateFilterItem, item.value === pastXDays ? classes.selectedItem : ''].join(' ')}
          onClick={() => onChange(item.value)}
        >
          <DazzedHeading12
            className={[classes.itemText, item.value === pastXDays ? classes.selectedItemText : ''].join(' ')}
            regular={false}
          >
            {item.text}
          </DazzedHeading12>
        </Grid>
      ))}
    </Grid>
  )
}

export default DateFilter
